import { Component, ChangeDetectorRef } from '@angular/core';
import { Mimetype } from 'app/shared/mimetype';
import { TranslateService } from '@ngx-translate/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { FileSizePipe } from '../../shared/file-size.pipe';

declare let $: any;

@Component({
   selector: 'app-upload-progress',
   templateUrl: './upload-progress.component.html',
   styleUrls: ['./upload-progress.component.css'],
   animations: [
      trigger('slide', [
        transition(':enter', [
          style({transform: 'translateY(100%)'}),
          animate('400ms ease-in', style({transform: 'translateY(0%)'}))
        ]),
        transition(':leave', [
         style({transform: 'translateY(0%)'}),
         animate('400ms ease-in', style({transform: 'translateY(100%)'}))
        ])
      ])
    ]
})
export class UploadProgressComponent {
   title: string;
   files = [];
   private errorCount = 0;
   expand = true;

   constructor(private translate: TranslateService, private cdr: ChangeDetectorRef, private fileSize: FileSizePipe) {}

   init(files: any): void {
      this.translate.get(files.length > 1 ? 'docList.uploading-multiple' : 'docList.uploading', { n: files.length }).subscribe(s => {
         this.title = s;
      });
      this.files = files;
   }

   initFolder(folder: any, name:string): void {
      this.translate.get('docList.uploading-folder', { n: name }).subscribe(s => {
         this.title = s;
      });
      this.files = [
         {
            name: name,
            mimeType: 'folder',
            isFolder: true,
         }
      ];
   }

   getIcon(file: any): string {
      file.mimeType = file.type;
      return Mimetype.getIcon(file, true);
   }

   limitExceed(i: number, size: number, limit: string): void {
      this.errorCount++;
      const c = document.getElementById('cancel-' + i);
      const d = document.getElementById('done-' + i);
      if (c && d) {
         c.style.display = 'none';
         d.style.display = 'none';
      }

      setTimeout(() => {
         let e = document.getElementById('percent-' + i);
         if (e) {
            e.className = 'error';
            e.innerText = ' — ' + this.fileSize.transform(size);
         }
         this.translate.get('alert.error_limitsize', { value: limit }).subscribe(s => {
            e = document.getElementById('progress-bar-' + i);
            if (e) {
               e.className = 'error';
               e.innerText = s;
            }
         });
      }, 100);
   }

   specialCharacter(i: number): void {
      this.errorCount++;
      const c = document.getElementById('cancel-' + i);
      const d = document.getElementById('done-' + i);
      if (c && d) {
         c.style.display = 'none';
         d.style.display = 'none';
      }

      setTimeout(() => {
         let e = document.getElementById('percent-' + i);
         if (e) {
            e.className = 'error';
            e.innerText = ' — file name';
         }
         this.translate.get('alert.create_folder_error').subscribe(s => {
            e = document.getElementById('progress-bar-' + i);
            if (e) {
               e.className = 'error';
               e.innerText = s;
            }
         });
      }, 100);
   }

   quotaExceed(i: number, size: number, error: string): void {
      this.errorCount++;
      const c = document.getElementById('cancel-' + i);
      const d = document.getElementById('done-' + i);
      if (c && d) {
         c.style.display = 'none';
         d.style.display = 'none';
      }

      let e = document.getElementById('percent-' + i);
      if (e) {
         e.className = 'error';
         e.innerText = ' — ' + this.fileSize.transform(size);
      }
      e = document.getElementById('progress-bar-' + i);
      if (e) {
         e.className = 'error';
         e.innerText = error;
      }
   }

   update(i: number, progress: number): void {
      const c = document.getElementById('cancel-' + i);
      const d = document.getElementById('done-' + i);
      if (c && d && progress === 100) {
         c.style.display = 'none';
         d.style.display = 'block';
      }
      let e = document.getElementById('progress-' + i);
      if (e) {
         e.style.width = progress + '%';
      }
      e = document.getElementById('percent-' + i);
      if (e) {
         e.innerText = ' — ' + progress + '%';
      }
   }

   complete(): boolean {
      if (this.errorCount === 0) {
         this.translate.get('docList.upload-completed', { n: this.files.length }).subscribe(s => {
            this.title = s;
         });
         return true;
      } else if (this.errorCount === this.files.length) {
         this.translate.get('docList.upload-failed', { n: this.errorCount }).subscribe(s => {
            this.title = s;
         });
         return false;
      } else {
         const param = { success: this.files.length - this.errorCount, fail: this.errorCount };
         this.translate.get('docList.upload-result', param).subscribe(s => {
            this.title = s;
         });
         return true;
      }

   }

   hide(): void {
      this.files = [];
      this.errorCount = 0;
   }

   toggle(): void {
      this.expand = !this.expand;
      this.cdr.detectChanges();
      $('#upload-wrapper').slideToggle();
   }

   calcDelay(): number {
      if (this.errorCount === 0) { return 800; }
      let delay = this.errorCount * 1000;
      if (delay < 3000) {
         delay = 3000;
      } else if (delay > 12000) {
         delay = 12000;
      }
      return delay;
   }

   cancel(file: any, i: number) {
      file.canceled = true;
      const error = 'Cancel';
      const c = document.getElementById('cancel-' + i);
      const d = document.getElementById('done-' + i);
      if (c && d) {
         c.style.display = 'none';
         d.style.display = 'none';
      }

      let e = document.getElementById('percent-' + i);
      if (e) {
         e.className = 'error';
         e.innerText = ' — ' + error;
      }
      e = document.getElementById('progress-bar-' + i);
      if (e) {
         e.className = 'error';
         e.innerText = error;
      }
   }

   cancelUpload(i: number, error: string): void {
      this.errorCount++;
      const c = document.getElementById('cancel-' + i);
      const d = document.getElementById('done-' + i);
      if (c && d) {
         c.style.display = 'none';
         d.style.display = 'none';
      }

      let e = document.getElementById('percent-' + i);
      if (e) {
         e.className = 'error';
         e.innerText = ' — ' + error;
      }
      e = document.getElementById('progress-bar-' + i);
      if (e) {
         e.className = 'error';
         e.innerText = error;
      }
   }
}
